import { loadPagesByBookId } from './../actions/entities/pages';

import { loadLayoutsByBookId } from './../actions/entities/layouts';
import { loadPlaceholdersByBookId } from './../actions/entities/placeholders';
import { loadBackgroundPlaceholderByBookId } from './../actions/entities/backgroundPlaceholders';
import { loadImagesByBookId } from './../actions/entities/images';
import { autofillFinished } from './../actions/entities/io';
import { loadCoverDetailsByBookId } from './../actions/entities/cover';
import { loadBookBackgroundType, loadEditorBookProperties } from './../actions/ui/bookProperties';
import { loadAutoFill } from './../actions/ui/setAutoFill';
import { loadTextsByBookId } from './../actions/entities/texts';
import { loadPageToViewed } from './../actions/ui/addPageToViewed';

import {
  loadBookSizesByBookId,
  loadBookCoverByBookId,
  loadPlaceholderBorderSize,
  loadBookContext,
  addCalendarYear,
  addCalendarMonth,
  addBookId,
} from './../actions/bookproperties';
import {
  loadDefaultImages, configExist,
} from './../helpers';
import { imageChange } from '../actions/ui/imageChange';
import { isSavedBook } from '../actions/ui/isSavedBook';
import { loadDatePlaceholderByBookId } from '../actions/entities/datePlaceholders';
import { backgroundImageSelected } from '../actions/ui/backgroundImageSelected';
import { dateImageSelected } from '../actions/ui/dateImageSelected';
import { getDomain, getParams } from './getParams';

function loadBookPartials(json, dispatch, coverSize, isConverted = false) {
  const { entities, bookProperties, editorUI } = json;

  const placeholderBorderSize = bookProperties.placeholderBorderSize ? bookProperties.placeholderBorderSize : 0;

  dispatch(addBookId(parseInt(bookProperties.calendarId, 10)));

  // Book properties, pages, layouts and placeholders
  dispatch(loadBookSizesByBookId(bookProperties.bookSizes));
  dispatch(loadBookCoverByBookId(bookProperties.cover));
  dispatch(loadBookContext(bookProperties.context));

  dispatch(loadPlaceholderBorderSize(placeholderBorderSize));
  if (!isConverted) {
    dispatch(loadPagesByBookId(entities.pages));
  }
  dispatch(loadLayoutsByBookId(entities.layouts));
  dispatch(loadPlaceholdersByBookId(entities.placeholders));

  // load BackgroundPlaceholder if exist
  if (entities.backgroundPlaceholders !== undefined) {
    dispatch(loadBackgroundPlaceholderByBookId(entities.backgroundPlaceholders));
  }

  // Load backgroundSelected
  if (editorUI.backgroundImageSelected) {
    dispatch(backgroundImageSelected(true));
  }

  // Load DateSelected
  if (editorUI.dateImageSelected) {
    dispatch(dateImageSelected(true));
  }

  if (entities.datePlaceholders !== undefined) {
    dispatch(loadDatePlaceholderByBookId(entities.datePlaceholders));
    dispatch(addCalendarYear(bookProperties.calendarStartYear));
    dispatch(addCalendarMonth(bookProperties.calendarStartMonth));
  }


  // load texts
  if (entities.texts) {
    dispatch(loadTextsByBookId(entities.texts));
  }

  // editorUI
  dispatch(loadBookBackgroundType(editorUI.bookProperties));
  dispatch(loadPageToViewed(editorUI.addPageToViewed));
  dispatch(loadAutoFill(editorUI.setAutoFill));
  dispatch(loadEditorBookProperties(editorUI.bookProperties));

  // Load images
  dispatch(loadImagesByBookId(entities.images));

  // Cover Details
  dispatch(loadCoverDetailsByBookId(entities.cover));

  if (!isConverted) {
    dispatch(autofillFinished(true));
  }
  dispatch(imageChange(false));

  /*
    dispatch(updateCoverMarginSize(coverSize));
  */
  dispatch(isSavedBook(true));
}


// Load gallery, and add new images
function loadNewImages(galleryURI, entities, store) {
  fetch(galleryURI)
    .then(response => response.json())
    .then((galleryData) => {
      if ('error' in galleryData) {
        throw galleryData.error;
      }

      const newImages = galleryData.items.filter(galleryElement => Object.values(entities.images.byId).filter(stateImage => stateImage.imageId === galleryElement.id).length === 0);
      loadDefaultImages(newImages, store);
    });
}

export function loadBook(galleryURI, response, store, lang, data) {
  return async (dispatch) => {
    let savedData = data.json;

    const firstGalleryImage = data.json.entities.images.byId[10].url;
    if (firstGalleryImage.indexOf('http://') === 0) {
      const updateSavedProtocol = await updateProtocol();
      savedData = updateSavedProtocol.success;
    }

    loadBookPartials(savedData, dispatch);
    loadNewImages(galleryURI, data.json.entities, store);
    fetch(galleryURI)
      .then(images => images.json())
      .then((galleryData) => {
        if ('error' in galleryData) {
          throw galleryData.error;
        }

        const oldImageIDs = [];
        const newImageIDs = [];

        Object.values(data.json.entities.images.byId).forEach((element) => {
          oldImageIDs.push(element.imageId);
        });

        Object.values(galleryData.items).forEach((element) => {
          newImageIDs.push(element.id);
        });
      });
  };
}


export async function updateProtocol() {
  const referer = getDomain();
  const legacyUrl = configExist('legacyUrl', referer);
  const updateUrl = await fetch(`${legacyUrl}/api/calendar/id/${getParams('calendarId')}/updateProtocolInEditorJsonForCalendars`, {
    cors: 'no-cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const updatedData = await updateUrl.json();
  return updatedData;
}



// WEBPACK FOOTER //
// ./src/redux/helpers/loadBook.js